import { categories } from "../../../mocks/guaData";

const quick = [
  { label: "瓜田热搜", href: "#hot" },
  { label: "四大分析视角", href: "#analysis" },
  { label: "深扒专栏", href: "#deep" },
  { label: "剧本拆解", href: "#playbook" },
  { label: "防晕指南", href: "#spot" },
  { label: "常见问答", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Footer() {
  return (
    <footer className="bg-background-200 py-14">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-bubble-chart-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                吃瓜<span className="text-primary-500">透视局</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              穿透流量，看见真相。我们以客观还原为原则，聚焦吃瓜事件背后的传播运作，
              帮你识破炒作套路、看透舆论引导，做一个清醒的理性吃瓜人。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-primary-600" aria-hidden="true"></i>
              本站内容为传播现象与营销机制的观察分析，不针对任何真实个人的事实指控。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {quick.map((q) => (
                <li key={q.href}>
                  <a
                    href={q.href}
                    className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    <i className="ri-arrow-right-s-line text-primary-500" aria-hidden="true"></i>
                    {q.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900">内容栏目</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categories.map((c) => (
                <li key={c}>
                  <a
                    href="#deep"
                    className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-700"
                  >
                    {c}
                  </a>
                </li>
              ))}
            </ul>
            <h4 className="mt-6 font-heading text-sm font-bold text-foreground-900">联系与合作</h4>
            <p className="mt-3 flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
              <a href="mailto:hi@chigua-toushi.example.com" className="transition-colors hover:text-primary-600">
                hi@chigua-toushi.example.com
              </a>
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 吃瓜透视局 · 保留所有权利
          </p>
          <p className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-fire-fill text-accent-600" aria-hidden="true"></i>
            穿透流量 · 看见真相 · 理性吃瓜
          </p>
        </div>
      </div>
    </footer>
  );
}